import { render, staticRenderFns } from "./ExpenseCreate.vue?vue&type=template&id=66406147"
import script from "./ExpenseCreate.vue?vue&type=script&lang=js"
export * from "./ExpenseCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports